import React from 'react';

import ssIMG from './images/steven_stat_75x75.gif';
import sldeIMG from './images/120x60_Geizhals_Logo_DE.png';

import klarnaImg from './images/klarna.png';
import visaMastercardAmexImg from './images/visa_mastercard_amex_20.png';
import PayPalImg from './images/paypal.png';

import lunaImages from './images/luna-grafik.png';

import {
  showFooterMiddlePart,
  showFooterPartner,
  facebookIMG,
  instagramIMG,
  twitterIMG,
  youtubeIMG,
  pinterestIMG,
  getFacebookName,
  getShopName,
  getInstagramName,
  getTwitterName,
  getYouTubeName,
  getPinterestName,
} from './overrides';

//import packageJson from '../../../package.json';

import './FooterMoluna.scss';
import {
  browserUrlToReactUrl,
  reactUrlToBrowserUrl,
} from '../../../../../urlParse';
import MolLink from './Menu/MolLink';

interface FooterMolunaProps {
  domainPrefix: string;
  showPartnerDiv: boolean;
  footerLinks: {
    pages_id: number;
    pages_title: string;
    alt_url: string;
  }[];
}

export default class FooterMoluna extends React.Component<FooterMolunaProps> {
  render() {
    let footerLinks = this.props.footerLinks ?? [];
    const footerMenu = (
      <div id="footerMenu" className="onerow-fluid">
        <div id="navSuppWrapper">
          <div id="footer-menu">
            <div id="footer-one" className="layer1">
              <ul className="content2">
                <li className="header">Informationen</li>
                <li>
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=contact_us'
                    }
                  >
                    Persönlicher Kontakt
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=shippinginfo'
                    }
                  >
                    Versand und Zahlung
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.props.domainPrefix + '/index.php?main_page=privacy'
                    }
                  >
                    Datenschutz
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=conditions'
                    }
                  >
                    AGB
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=widerrufsrecht'
                    }
                  >
                    Widerrufsrecht
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=widerrufsformular'
                    }
                    className="widerruf-footer-btn"
                  >
                    Widerruf einlegen
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.props.domainPrefix + '/index.php?main_page=impressum'
                    }
                  >
                    Impressum
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.props.domainPrefix + '/index.php?main_page=page_2'
                    }
                  >
                    Batterieentsorgung
                  </a>
                </li>
              </ul>
            </div>

            {showFooterMiddlePart() ? (
              <div id="footer-three" className="layer1">
                <h2 className="hide">Links</h2>
                <ul className="content1">
                  {/* style="display: none;" >*/}
                  {footerLinks.map((item, index) => {
                    let href = '';
                    let useMolLink = false;
                    let reactLink = '';

                    if (item.alt_url != '') {
                      let molHref = null;
                      reactLink = browserUrlToReactUrl(item.alt_url, null);
                      if (reactLink != '') {
                        useMolLink = true;

                        let newUrl = reactUrlToBrowserUrl(
                          reactLink,
                          null,
                          null,
                        );

                        molHref = newUrl.substr(1);
                      }

                      href = item.alt_url;
                    } else {
                      href =
                        '/index.php?main_page=page&id=' +
                        item.pages_id +
                        '&chapter=1';
                    }

                    return (
                      <li key={'dynamicMenu' + index}>
                        {useMolLink ? (
                          <MolLink
                            to={reactLink}
                            href={this.props.domainPrefix + href}
                          >
                            {item.pages_title}
                          </MolLink>
                        ) : (
                          <a href={this.props.domainPrefix + href}>
                            {item.pages_title}
                          </a>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : null}

            <div id="footer-four" className="layer1">
              <ul className="content1">
                <li className="header">Zahlungsarten</li>
                <li>
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=page&id=3&chapter=1'
                    }
                    title="Einfach, schnell und ohne weitere Kosten auf Rechung einkaufen und Ihre Ware erst in 14 Tagen bezahlen"
                  >
                    Rechnung
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=page&id=3&chapter=1'
                    }
                    title="Einfach, schnell und ohne weitere Kosten per Lastschrift einkaufen"
                  >
                    Lastschrift
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=page&id=3&chapter=1'
                    }
                    title="Bezahlen Sie Ihren Einkauf per Mastercard oder Visa oder American Express Kreditkarte"
                  >
                    Kreditkarte
                  </a>
                </li>

                <li>
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=page&id=3&chapter=1'
                    }
                    title="Bequem Ihren Einkauf in kleinen Raten bezahlen"
                  >
                    Ratenzahlung
                  </a>
                </li>
              </ul>
            </div>
            <div className="layer1">
              <ul>
                <li>
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=page&id=3&chapter=1'
                    }
                  >
                    <img
                      src={klarnaImg}
                      title="mit Klarna Zahlung auf Rechnung, per Lastschrift und per Kreditkarte u.v.m."
                    ></img>
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=page&id=3&chapter=1'
                    }
                    title="Bezahlen Sie Ihren Einkauf per Mastercard oder Visa oder American Express Kreditkarte"
                  >
                    <img
                      src={visaMastercardAmexImg}
                      title="Mastercard und Visa und American Express"
                    ></img>
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=page&id=3&chapter=1'
                    }
                  >
                    <img
                      src={PayPalImg}
                      title="schnell und einfach mit Ihrem Paypal Account bei uns bezahlen"
                    ></img>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );

    const footerLuna = (
      <div id="luna-element">
        <img id="luna-grafik" src={lunaImages} alt="Luna" title="Luna" />
        <span className="luna-headline">Alle Mangas versandkostenfrei!</span>
        <span className="luna-subline">
          Starke Angebote & bester Service bei deinem Manga und Anime Dealer.
        </span>
        <a
          className="button"
          href={
            this.props.domainPrefix +
            '/index.php?main_page=advanced_search_result&keyword=*&fqZZZSchlagwort=manga&fqZZZSprache=deutsch&fqZZZKategorie=buch'
          }
        >
          zu den Mangas
        </a>
      </div>
    );

    let version = '';
    if (process.env.CI_PIPELINE_ID != null)
      version = '#' + process.env.CI_PIPELINE_ID;

    let buildYear = new Date().getFullYear();

    return (
      <div>
        <footer id="footer">
          {footerMenu}
          {showFooterPartner() ? (
            <div id="shoppartner">
              {this.props.showPartnerDiv ? (
                <React.Fragment>
                  <a
                    href="http://www.idealo.de/preisvergleich/Shop/302706.html"
                    target="_blank"
                  >
                    <img
                      data-cmp-src="https://img.idealo.com/folder/Shop/302/7/302706/s1_rating_extern2.png"
                      data-cmp-vendor="s1459"
                      alt="idealo"
                      className="partner cmplazyload"
                    ></img>
                  </a>
                  <a href="http://www.geizkragen.de" target="_blank">
                    <img src={ssIMG} className="partner"></img>
                  </a>
                  <a href="http://geizhals.at" target="_blank">
                    <img src={sldeIMG} className="partner"></img>
                  </a>
                </React.Fragment>
              ) : null}
            </div>
          ) : null}
          <div className="copyright">
            <div id="social-media">
              {getFacebookName() != '' ? (
                <a
                  href={'https://www.facebook.com/' + getFacebookName()}
                  target="_blank"
                  title={getShopName() + ' auf Facebook'}
                >
                  <img
                    src={facebookIMG}
                    alt="facebook link"
                    className="smi facebook"
                  ></img>
                </a>
              ) : null}
              {getInstagramName() != '' ? (
                <a
                  href={'https://www.instagram.com/' + getInstagramName() + '/'}
                  target="_blank"
                  title={getShopName() + ' auf Instagram'}
                >
                  <img
                    src={instagramIMG}
                    alt="instagram link"
                    className="smi instagram"
                  ></img>
                </a>
              ) : null}
              {getTwitterName() != '' ? (
                <a
                  href={'https://twitter.com/' + getTwitterName()}
                  target="_blank"
                  title={getShopName() + ' bei Twitter'}
                >
                  <img
                    src={twitterIMG}
                    alt="twitter link"
                    className="smi twitter"
                  ></img>
                </a>
              ) : null}
              {getYouTubeName() != '' ? (
                <a
                  href={'https://www.youtube.com/channel/' + getYouTubeName()}
                  target="_blank"
                  title={getShopName() + ' bei YouTube'}
                >
                  <img
                    src={youtubeIMG}
                    alt="youtube link"
                    className="smi youtube"
                  ></img>
                </a>
              ) : null}
              {getPinterestName() != '' ? (
                <a
                  href={'https://de.pinterest.com/' + getPinterestName() + '/'}
                  target="_blank"
                  title={getShopName() + ' auf Pinterest'}
                >
                  <img
                    src={pinterestIMG}
                    alt="pinterest link"
                    className="smi pinterest"
                  ></img>
                </a>
              ) : null}
            </div>

            <div id="siteinfoLegal" className="legalCopyright">
              © {buildYear}{' '}
              <a href={this.props.domainPrefix + '/'}>www.MOLUNA.de</a> ·
              Powered by{' '}
              <a
                href="http://www.zen-cart-pro.at"
                target="_blank"
                rel="nofollow"
              >
                Zen Cart
              </a>{' '}
              & React {version}
              <div className="bottom_button">&nbsp;</div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}
